import {
  SupplementKnowledgeAnswer,
  SupplementKnowledgeValueMessage,
} from 'services/api/supplementKnowledge';

export const messageToAnswer = (messageList: Conversation.Message[]) => {
  // 2. 将 TEXT 类型的消息合并成一个
  const textMessages: string[] = [];
  const nonTextMessages: Conversation.Message[] = [];

  messageList.forEach((item) => {
    if (item.messageType === 'TEXT' && item.textContent?.text) {
      textMessages.push(item.textContent.text);
    } else {
      nonTextMessages.push(item);
    }
  });

  // 构建 answers 数组
  const answers: SupplementKnowledgeAnswer[] = [];

  // 如果有文本消息，合并成一个 TEXT 类型的 answer
  if (textMessages.length > 0) {
    answers.push({
      message: textMessages.join('\n'), // 用换行符连接多个文本消息
      messageId: messageList.findLast((m) => m.messageType === 'TEXT')?.msgId || '', // 使用最后一个文本消息的 msgId
      msgType: 'TEXT',
    });
  }

  // 处理非文本消息（图片和视频）
  nonTextMessages.forEach((item) => {
    const { messageType, imageContent, videoContent, msgId } = item;

    if (messageType === 'IMAGE' && imageContent) {
      answers.push({
        messageId: msgId,
        url: imageContent.externalImgUrl,
        localUrl: imageContent.imgUrl,
        thumbWidth: imageContent.width.toString(),
        thumbHeight: imageContent.height.toString(),
        msgType: 'IMAGE',
      });
    }

    if (messageType === 'VIDEO' && videoContent) {
      answers.push({
        messageId: msgId,
        url: videoContent.videoUrl,
        localUrl: videoContent.localVideoUrl,
        thumbUrl: videoContent.thumbUrl,
        thumbWidth: videoContent.thumbWidth?.toString(),
        thumbHeight: videoContent.thumbHeight?.toString(),
        durationSeconds: videoContent.durationSeconds?.toString(),
        msgType: 'VIDEO',
      });
    }
  });

  return answers;
};

export const messageToAnswerV2 = (
  messageList: Partial<Conversation.Message>[],
): SupplementKnowledgeValueMessage[] => {
  const results: SupplementKnowledgeValueMessage[] = [];
  messageList.forEach((item) => {
    const {
      messageType,
      textContent,
      imageContent,
      videoContent,
      msgId,
      msgFromType,
      botReplyType: itemBotReplyType,
      extraInfo,
    } = item;

    const isBotReply = msgFromType === 'BOT';
    const botReplyType = isBotReply ? itemBotReplyType : undefined;
    const botReplyMsgId = extraInfo?.reqMsgId?.toString();

    if (messageType === 'TEXT' && textContent?.text) {
      results.push({
        message: textContent.text,
        messageId: msgId,
        msgType: 'TEXT',
        isBotReply,
        botReplyType,
        botReplyMsgId,
        botDialogueReplyType: extraInfo?.botDialogueReplyType,
      });
    }

    if (messageType === 'IMAGE' && imageContent) {
      results.push({
        messageId: msgId,
        url: imageContent.externalImgUrl,
        localUrl: imageContent.imgUrl,
        thumbWidth: imageContent.width.toString(),
        thumbHeight: imageContent.height.toString(),
        msgType: 'IMAGE',
        isBotReply,
        botReplyType,
        botReplyMsgId,
        botDialogueReplyType: extraInfo?.botDialogueReplyType,
      });
    }

    if (messageType === 'VIDEO' && videoContent) {
      results.push({
        messageId: msgId,
        url: videoContent.videoUrl,
        localUrl: videoContent.localVideoUrl,
        thumbUrl: videoContent.thumbUrl,
        thumbWidth: videoContent.thumbWidth?.toString(),
        thumbHeight: videoContent.thumbHeight?.toString(),
        durationSeconds: videoContent.durationSeconds?.toString(),
        msgType: 'VIDEO',
        isBotReply,
        botReplyType,
        botReplyMsgId,
        botDialogueReplyType: extraInfo?.botDialogueReplyType,
      });
    }
  });

  return results;
};
